// extracted by mini-css-extract-plugin
export var header = "Hero-module--header--fd22d";
export var headerWrapper = "Hero-module--header-wrapper--ed6a2";
export var headerWrapperHidden = "Hero-module--header-wrapper--hidden--e1763";
export var header__btnMobileMenu = "Hero-module--header__btnMobileMenu--29555";
export var header__button = "Hero-module--header__button--e4b26";
export var header__logo = "Hero-module--header__logo--077b0";
export var hero = "Hero-module--hero--ddb54";
export var hero__bannerIcon = "Hero-module--hero__bannerIcon--4aeaa";
export var hero__bannerText = "Hero-module--hero__bannerText--8c26d";
export var hero__ctaButtonWrapper = "Hero-module--hero__ctaButtonWrapper--5bd04";
export var hero__estLabel = "Hero-module--hero__estLabel--d8de6";
export var hero__footer = "Hero-module--hero__footer--53efc";
export var hero__heroPart = "Hero-module--hero__heroPart--8611f";
export var hero__img = "Hero-module--hero__img--a6bb6";
export var hero__parts = "Hero-module--hero__parts--b1eda";
export var hero__text = "Hero-module--hero__text--2ae2b";
export var hero__text___withLaunchingInfo = "Hero-module--hero__text___withLaunchingInfo--e572c";
export var hero__topBanner = "Hero-module--hero__topBanner--e2860";
export var hero__video = "Hero-module--hero__video--caaa6";